import { Component, OnInit, inject } from '@angular/core';
import {PageRequest} from '../../../core/pagination/page-request';
import {SignaalkaartAntwoord} from '../../../signaalkaart/signaalkaart-antwoord';
import {SortOrder} from '../../../core/sort/sort-order';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {Page} from '../../../core/pagination/page';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {ActivatedRoute, Router} from '@angular/router';
import {first, map, mergeMap, tap} from 'rxjs/operators';
import {SignaalkaartAntwoordService} from '../../../signaalkaart/signaalkaart-antwoord.service';
import {Signaalkaarten} from '../../../signaalkaart/signaalkaarten';
import {SignaalkaartService} from '../../../signaalkaart/signaalkaart.service';

@Component({
    templateUrl: './signaalkaart-antwoorden.page.html',
    styleUrls: ['./signaalkaart-antwoorden.page.scss'],
    standalone: false
})
export class SignaalkaartAntwoordenPage implements OnInit {
  private clientService = inject(ClientService);
  private signaalkaartService = inject(SignaalkaartService);
  private signaalkaartAntwoordService = inject(SignaalkaartAntwoordService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  client$: Observable<Client>;
  signaalkaarten$: Observable<Signaalkaarten>;
  initialPageRequest: PageRequest<SignaalkaartAntwoord> = PageRequest.firstPageRequest<SignaalkaartAntwoord>(SortOrder.DESCENDING, 5);
  signaalkaartAntwoordenPage$: Subject<Page<SignaalkaartAntwoord>> = new ReplaySubject<Page<SignaalkaartAntwoord>>(1);

  ngOnInit(): void {
    this.client$ = this.route.paramMap.pipe(
      map(paramMap => paramMap.get('id')),
      mergeMap(clientId => this.clientService.getClientById$(clientId))
    );
    this.client$.pipe(
      first(),
      mergeMap(client => this.getSignaalkaartAntwoorden$(client, this.initialPageRequest)),
    ).subscribe();
    this.signaalkaarten$ = this.signaalkaartService.getSignaalkaarten$();
  }

  navigateToSignaalkaartAntwoord(client: Client, signaalkaartAntwoord: SignaalkaartAntwoord): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/signaalkaarten/${signaalkaartAntwoord.getId()}`);
  }

  navigateToClient(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}`);
  }

  onPageChange(client: Client, pageRequest: PageRequest<SignaalkaartAntwoord>): void {
    this.getSignaalkaartAntwoorden$(client, pageRequest).subscribe();
  }

  private getSignaalkaartAntwoorden$(client: Client, pageRequest: PageRequest<SignaalkaartAntwoord>): Observable<Page<SignaalkaartAntwoord>> {
    return this.signaalkaartAntwoordService
      .getSignaalkaartAntwoordenPage$(client.getId(), pageRequest)
      .pipe(tap(page => this.signaalkaartAntwoordenPage$.next(page)));
  }
}
